/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `aluminium_aerosol` - Aluminium Aerosol
* `food_can` - Food Can
* `non_metal` - Non Metal
* `other_aluminium` - Other Aluminium
* `other_metal` - Other Metal
* `ubc` - UBC
* `foil_and_tray` - Foil and Tray
* `clear` - Clear
* `white` - White
* `brown` - Brown
* `light_blue` - Light Blue
* `dark_blue` - Dark Blue
* `green` - Green
* `other_colour` - Other Colour
* `clear_non_food_grade` - Clear Non Food Grade
* `clear_pet_tray` - Clear PET Tray
* `pet_tray_contaminated_clear` - Clear Contaminated PET Tray
* `film` - Film
* `other_plastic` - Other Plastic
* `polypropylene` - PP
* `non_plastic` - Non Plastic
* `metal` - Metal
* `prohibitive` - Prohibitive
* `full_sleeve` - Full Sleeve Bottle
* `oil_bottle` - Oil Bottle
* `pet_bottle_dirty` - Dirty Bottles
* `hdpe_natural_food_grade` - HDPE Natural Food Grade
* `hdpe_natural_non_food_grade` - HDPE Natural Non-Food Grade
* `hdpe_white_food_grade` - HDPE White Food Grade
* `hdpe_white_non_food_grade` - HDPE White Non-Food Grade
* `hdpe_silicon_tubes` - HDPE Silicon Tubes
* `hdpe_jazz` - HDPE Jazz
* `expanded_polystyrene` - Expanded Polystyrene
* `pet` - PET
* `waste` - Waste
 */
export type Operand = typeof Operand[keyof typeof Operand];


export const Operand = {
  aluminium_aerosol: 'aluminium_aerosol',
  food_can: 'food_can',
  non_metal: 'non_metal',
  other_aluminium: 'other_aluminium',
  other_metal: 'other_metal',
  ubc: 'ubc',
  foil_and_tray: 'foil_and_tray',
  clear: 'clear',
  white: 'white',
  brown: 'brown',
  light_blue: 'light_blue',
  dark_blue: 'dark_blue',
  green: 'green',
  other_colour: 'other_colour',
  clear_non_food_grade: 'clear_non_food_grade',
  clear_pet_tray: 'clear_pet_tray',
  pet_tray_contaminated_clear: 'pet_tray_contaminated_clear',
  film: 'film',
  other_plastic: 'other_plastic',
  polypropylene: 'polypropylene',
  non_plastic: 'non_plastic',
  metal: 'metal',
  prohibitive: 'prohibitive',
  full_sleeve: 'full_sleeve',
  oil_bottle: 'oil_bottle',
  pet_bottle_dirty: 'pet_bottle_dirty',
  hdpe_natural_food_grade: 'hdpe_natural_food_grade',
  hdpe_natural_non_food_grade: 'hdpe_natural_non_food_grade',
  hdpe_white_food_grade: 'hdpe_white_food_grade',
  hdpe_white_non_food_grade: 'hdpe_white_non_food_grade',
  hdpe_silicon_tubes: 'hdpe_silicon_tubes',
  hdpe_jazz: 'hdpe_jazz',
  expanded_polystyrene: 'expanded_polystyrene',
  pet: 'pet',
  waste: 'waste',
} as const;
